import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { RequirementField } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { Subject } from 'rxjs';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { tap, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ba-number',
    templateUrl: 'number-attribute.component.html'
})

export class NumberAttributeComponent implements OnInit, OnDestroy {

    @Input() field: RequirementField;
    @Input() form: UntypedFormGroup;
    @Input() disabled: boolean;

    percentMask = createNumberMask({
        prefix: '',
        suffix: '%',
        integerLimit: 3
    });

    mask = createNumberMask({
        prefix: '',
        suffix: '',
        integerLimit: 30
    });

    errorMessageMap = {
        'min': 'Cannot be less than 0%',
        'max': 'Cannot be greater than 100%'
    };

    destroyed$ = new Subject<void>();

    ngOnInit() {
        this.control.valueChanges.pipe(
            tap((value: string = '') => {
                if (typeof value === 'string') {
                    const unmaskedValue = value.replace(/\D+/g, '');
                    this.control.setValue(unmaskedValue, { emitEvent: false, emitModelToViewChange: false });
                } else {
                    this.control.setValue(value + '');
                }
            }),
            takeUntil(this.destroyed$)
        ).subscribe();

        if (this.isPercentAttribute) {
            this.control.setValidators([Validators.min(0), Validators.max(100)]);
        }
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }

    get showError() {
        return this.control.errors;
    }

    get errorMessages() {
        if (!this.control.errors) {
            return [];
        }
        const keys = Object.keys(this.control.errors);
        return keys.map(key => this.errorMessageMap[key]);
    }

    get control() {
        return this.form.controls[this.field.alias];
    }

    get isPercentAttribute() {
        return [
            'percentOwnership',
            'revolvingAvailablePercent'
        ].includes(this.field.alias);
    }
}
